export default "__VITE_PUBLIC_ASSET__22939e96__"